import React, { useState } from 'react';
import LoginPage from './LoginPage';
import LetterPage from './LetterPage';
import ArchivesPage from './ArchivesPage';
import ArchiveDetailPage from './ArchiveDetailPage';
import { archives } from './archives';

function getLatestLetter(letters) {
  return letters.reduce((latest, letter) => {
    if (!latest) return letter;
    return new Date(letter.dateArchived) > new Date(latest.dateArchived) ? letter : latest;
  }, null);
}

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  // Set your anniversary date here in MM/DD/YYYY format
  const anniversary = "10/24/2020";
  const [page, setPage] = useState('letter'); // 'letter', 'archives', 'archiveDetail'
  const [selectedArchive, setSelectedArchive] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() === anniversary) {
      setAuthenticated(true);
      setError("");
    } else {
      setError("Incorrect. Please try again.");
    }
  };

  if (!authenticated) {
    return (
      <LoginPage
        input={input}
        setInput={setInput}
        handleSubmit={handleSubmit}
        error={error}
      />
    );
  }

  if (page === 'archives') {
    return (
      <ArchivesPage
        onSelectArchive={archive => {
          setSelectedArchive(archive);
          setPage('archiveDetail');
        }}
        onBack={() => setPage('letter')}
      />
    );
  }

  if (page === 'archiveDetail') {
    return (
      <ArchiveDetailPage
        archive={selectedArchive}
        onBack={() => setPage('archives')}
      />
    );
  }

  // Show the latest letter by dateArchived
  const latestLetter = getLatestLetter(archives);
  return <LetterPage onShowArchives={() => setPage('archives')} letter={latestLetter} />;
}

export default App;
